import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setGlobalMode } from '../../features/counter/eqFiltersReducer';

const GlobalStatusController = () => {
    const globalMode = useSelector((state) => state.filters.globalMode); // Access global mode
    const dispatch = useDispatch();

    // Handler to set the global mode
    const handleSetMode = (mode) => {
        dispatch(setGlobalMode(mode)); // Dispatch the selected mode
    };

    return (
        <div className="global-status-controller">
            <button
                className={`global-button ${globalMode === 'pure-audio' ? 'active' : ''}`}
                onClick={() => handleSetMode('pure-audio')}
            >
                Pure Audio
            </button>
            <button
                className={`global-button ${globalMode === 'question' ? 'active' : ''}`}
                onClick={() => handleSetMode('question')}
            >
                Question
            </button>
            <button
                className={`global-button ${globalMode === 'user-setting' ? 'active' : ''}`}
                onClick={() => handleSetMode('user-setting')}
            >
                Your Setting
            </button>
            <button
                className={`global-button ${globalMode === 'check' ? 'active' : ''}`}
                onClick={() => handleSetMode('check')}
            >
                Check
            </button>
        </div>
    );
};

export default GlobalStatusController;
